import { render, staticRenderFns } from "./NavigateSTB.vue?vue&type=template&id=c24208e8&scoped=true"
import script from "./NavigateSTB.vue?vue&type=script&lang=js"
export * from "./NavigateSTB.vue?vue&type=script&lang=js"
import style0 from "./NavigateSTB.vue?vue&type=style&index=0&id=c24208e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24208e8",
  null
  
)

export default component.exports